import { Link } from "react-router-dom";
import { hotRanking, featuredStats } from "@/mocks/home";

export default function HotRankingSection() {
  return (
    <section className="px-6 md:px-10 py-14 md:py-18 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left - Stats */}
          <div className="lg:w-[400px] shrink-0">
            <span className="inline-block text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              数据说话
            </span>
            <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight mb-12">
              千万用户信赖的
              <br />
              娱乐资讯平台
            </p>

            <div className="grid grid-cols-2 gap-8">
              {featuredStats.map((stat) => (
                <div key={stat.label}>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-7 h-7 flex items-center justify-center">
                      <i className={`${stat.icon} text-lg text-accent-500`}></i>
                    </div>
                  </div>
                  <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-1">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Hot Ranking */}
          <div className="flex-1">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                  <i className="ri-fire-line mr-1.5"></i>
                  热搜榜
                </span>
                <span className="text-xs text-foreground-500">实时更新</span>
              </div>
            </div>

            <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              {hotRanking.map((item, index) => (
                <Link
                  key={item.rank}
                  to={`/article/${item.slug}`}
                  className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors duration-200 cursor-pointer ${
                    index < hotRanking.length - 1 ? "border-b border-background-200/50" : ""
                  }`}
                >
                  {/* Rank */}
                  <div
                    className={`w-8 h-8 flex items-center justify-center rounded-lg shrink-0 ${
                      item.rank <= 3
                        ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <span className="text-sm font-bold">{item.rank}</span>
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-950 truncate">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs text-foreground-500">{item.category}</span>
                    </div>
                  </div>

                  {/* Views & Trend */}
                  <div className="flex items-center gap-3 shrink-0">
                    <span className="text-xs text-foreground-500">{item.views}</span>
                    <span className="w-5 h-5 flex items-center justify-center">
                      {item.trend === "up" && (
                        <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                      )}
                      {item.trend === "down" && (
                        <i className="ri-arrow-down-line text-secondary-500 text-sm"></i>
                      )}
                      {item.trend === "new" && (
                        <span className="text-[10px] font-bold text-accent-500">NEW</span>
                      )}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}